import { useCallback, useEffect, useState } from "react";
import { Activity } from "lucide-react";
import { API, get } from "@/lib/api";
import { DASHBOARD } from "@/constants/testIds";
import StatusPanel from "@/pages/StatusPanel";

function Loader() {
  return (
    <div className="loader" data-testid={DASHBOARD.loading} role="status">
      <img src="/tri-logo.png" alt="" className="loader-logo" />
      <div className="loader-bar"><i /></div>
      <span>Loading dashboard…</span>
    </div>
  );
}

export default function Dashboard() {
  const [state, setState] = useState("loading");
  const [loaded, setLoaded] = useState(false);
  const [panel, setPanel] = useState(false);
  const [v, setV] = useState(0);
  const [held, setHeld] = useState("");

  const check = useCallback(async () => {
    const s = await get("/dashboard/status");
    if (s.status === 401) {
      window.location.replace(`/login?next=${encodeURIComponent(window.location.pathname)}${window.location.hash}`);
      return;
    }
    const ok = s.ok && s.data.published;
    setHeld(s.ok && !s.data.running && s.data.last_result === "fail"
      ? ((s.data.blocked || []).length || (s.data.last_message || "").includes("stage compare") ? "Refresh held" : "Refresh failed") : "");
    setState(ok ? "ready" : "empty");
    if (!ok) setPanel(true);
  }, []);

  useEffect(() => { check(); }, [check]);
  const reload = useCallback(() => { setLoaded(false); setV((x) => x + 1); check(); }, [check]);

  return (
    <div className="dash">
      {state !== "empty" && (
        <iframe key={v} title="TRI Grants & Funds dashboard" className={`frame ${loaded ? "in" : ""}`} data-testid={DASHBOARD.frame}
          src={`${API}/dashboard/page${window.location.hash}`} onLoad={() => setLoaded(true)} />
      )}
      {state !== "empty" && !loaded && <Loader />}
      {state === "empty" && (
        <div className="center" data-testid={DASHBOARD.empty}>
          <div className="empty">
            <h2>No page has been published yet</h2>
            <p>The first refresh pulls mGrant, builds the page and runs every gate. It takes about 4 minutes. Follow it in the status panel.</p>
            <a href="/api/auth/logout" className="link" data-testid={DASHBOARD.signOut}>Sign out</a>
          </div>
        </div>
      )}
      {!panel && (
        <button className={`fab ${held ? "held-fab" : ""}`} onClick={() => setPanel(true)} data-testid={DASHBOARD.statusToggle}
          aria-label={held ? `Refresh status: ${held}` : "Refresh status"}>
          <Activity size={14} /> {held || "Status"}
          {held && <i className="fab-dot" data-testid="dashboard-held-dot" />}
        </button>
      )}
      {panel && <StatusPanel onClose={() => setPanel(false)} onPublished={reload} />}
    </div>
  );
}
